import {html} from "lit-element";
import "@stofloos/components/organisms/tables/table-dynamic";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "@stofloos/components/molecules/dialogs/dialog-simple";
import "@stofloos/components/molecules/forms/sw-form";
import "@stofloos/components/atoms/inputs/input-checkbox";
import "@stofloos/components/atoms/buttons/button-contained";
import "@stofloos/components/atoms/buttons/button-outlined";
import "@stofloos/components/atoms/buttons/button-text";
import "@stofloos/components/atoms/loaders/sw-fullscreen-spinner";

import {style} from "./style";
import {StofwareCrudSingle} from "@stofloos/core/base/sw-crud-single";
import {formToJSON, getFormElements, validateForm} from "@stofloos/utils/sw-constants";
import moment from "moment";

import merge from "lodash-es/merge";
import {store} from "@stofloos/stores/store";
import {initRequest} from "@stofloos/actions/requests";
import {createObject} from "@stofloos/actions/crud";

const payment = [
    {
        "elements": [
            {
                "label": "Ja, ik ga akkoord met de Algemene voorwaarden.",
                "class": "w-100",
                "name": "agreed",
                "type": "checkbox",
                "required": true
            }
        ],
        "description": "U wordt doorverwezen naar de betalingsomgeving waar u de betaling kunt voorzetten. Al onze betalingen verlopen via mollie.nl."
    }
];

class PageEvent extends StofwareCrudSingle {
    static get styles() {
        return [
            LayoutFlex,
            style
        ]
    }

    static get properties() {
        return {
            label: String,
            banner: String,
            config: Array,
            active: {type: Boolean},
            isValidForm: {type: Boolean},
            voucherAmount: {type: Number},
            voucherResponse: {type: String},
            voucherApplied: {type: Boolean},
            voucherCodes: {type: Object},
            participants: Array
        }
    }

    constructor() {
        super();
        this.participants = [{}];
        this.voucherCodes = {};
        this.voucherAmount = 0;

        store.dispatch(initRequest("enrollment", "enroll"));
        store.dispatch(initRequest("voucher", "voucher/validate"));
    }

    updated(changedProperties) {
        if(this.active && changedProperties.has('id') && this.id !== "undefined" && this.object !== "undefined") {
            this.participants = [{}];
            this.readObject();
        }

        if(changedProperties.has('object')) {
            if(this.object.min_partcipants_per_enrollment > 1) {
                this.participants = [];
                for (let i = 0; i < this.object.min_partcipants_per_enrollment; i++) {
                    this.participants.push({});
                }
            }
            const sessionData = sessionStorage.getItem('event_'+this.object.id);
            if(sessionData){
                this.participants = JSON.parse(sessionData);
            }
        }
    }

    render() {
        const organisationForm = 5;
        const workshopForm = this.object && this.object.information && this.object.information.workshop_form_id ? this.object.information.workshop_form_id : 7;

        return html`

            <sw-fullscreen-spinner ?active="${this.isLoading}"></sw-fullscreen-spinner>
            ${!this.isLoading && this.object ? html`
                <div class="page-container layout vertical center">
                    <div class="banner-container">
                        <slot></slot>
                        <div style="background-image: url('${this.banner}');" class="banner layout vertical center-center">
                            <h1>${this.object.title}</h1>
                            
                        </div>
                    </div>
                    
                    <div class="section first shadow">
                        <h1>Aanmeldformulier ${this.object.title}</h1>
                        <p>${this.object.description}</p>
                        <div style="margin-bottom: 40px;">
                            <div class="layout horizontal">
                                <strong class="flex">Aanmelddatum</strong>
                                <span class="flex">
                                        ${this.object.end_date ? html`tot ${moment(this.object.end_date).format('D MMMM YYYY')}` : ``}
                                </span>
                            </div>
                         
                            
                            ${this.object.location ? html`
                                <div class="layout horizontal">
                                    <strong class="flex">Locatie</strong>
                                    <span class="flex">${this.object.location}</span>
                                </div>
                            ` : ``}
                            
                            ${this.object.accreditation ? html`
                                <div class="layout horizontal">
                                    <strong class="flex">Accreditatie</strong>
                                    <span class="flex">${this.object.accreditation}</span>
                                </div>
                            ` : ``}
                           
                            <div class="layout horizontal">
                                <strong class="flex">Prijs</strong>
                                <span class="flex">€ ${this.object.price.toFixed(2).replace('.', ',')} p.p.</span>
                            </div>
                        </div>
                        ${moment(this.object.end_date, "YYYY-MM-DD") > moment() || !this.object.end_date ? html`
                        
                                <sw-form class="form-section" .formId="${organisationForm}" ></sw-form>

                                ${this.participants && this.participants.map((participant, index)=> {
                                    participant['target_groups'] = this.object.target_groups;
                                    return html`
                                        <h3 style="margin: 15px;">Persoonlijke gegevens deelnemer ${this.object.max_partcipants_per_enrollment === 1 ? "" : (index+1)}</h3>
                                        <sw-form .config="${this.object.form.definition}" .object="${participant}"></sw-form>
                                        ${this.object.min_partcipants_per_enrollment < (index+1) ? html`<button-outlined @click="${() => this.removeParticipant(index)}" label="Bovenstaande persoon verwijderen"><sw-icon icon="trash-alt"></sw-icon></button-outlined>` : ``}
                                    `
                                })}
                                
                                ${!this.object.max_partcipants_per_enrollment || this.participants < this.object.max_partcipants_per_enrollment ? html`
                                <div class="layout vertical align-right">
                                        <button-text style="margin-left: 0;" @click="${this.addParticipant}" label="Extra deelnemer toevoegen"></button-text>
                                </div>
                                ` : ``}
                            
                                <sw-form class="form-section" .formId="${workshopForm}" .object="${this.object}"></sw-form>
                            
                                <div class="layout vertical payment-summary">
                                    <div class="layout horizontal">
                                        <h4 class="flex">Betaaloverzicht</h4>
                                    </div>
                                    <div class="layout horizontal">
                                        <div class="flex">${moment().format('D MMMM YYYY')}</div>
                                        <div class="flex">${this.object.title}</div>
                                        <div class="flex">Aantal: ${this.participants.length}</div>
                                        <div>BTW: 0%</div>
                                        <div class="flex" style="text-align: right;">Prijs: € ${(this.participants.length*this.object.price).toFixed(2).replace('.', ',')}</div>
                                    </div>
                                    
                                ${this.voucherCodes && Object.keys(this.voucherCodes).map((key)=> {
                                        const voucher = this.voucherCodes[key];
                                        return html`
                                            <div class="layout horizontal">
                                                <div class="flex"></div>
                                                <div class="flex"></div>
                                                <div class="flex"></div>
                                                <p class="flex" style="text-align: right;">Voucher korting (${voucher.voucher_code}): € -${voucher.amount.toFixed(2).replace('.', ',')}</p>
                                            </div>
                                        `
                                    })}
                                
                                    <div class="layout horizontal">
                                        <div class="flex"></div>
                                        <div class="flex"></div>
                                        <div class="flex"></div>
                                        <div></div>
                                        <strong class="flex" style="text-align: right;">Totaal: € ${((this.participants.length*this.object.price) - this.voucherAmount).toFixed(2).replace('.', ',')}</strong>
                                    </div>
                                </div>
                                <div class="layout vertical">
                                    <div class="layout horizontal">
                                        <input-default id="voucherCode" style="margin-left: auto; margin-right:0;" name="voucher_code" 
                                                        type="text" 
                                                        label="Vouchercode"></input-default> 
                                        <button-outlined style="margin: 30px 0 40px 10px;" @click="${this.checkCoupon}" label="toepassen"></button-outlined>
                                    </div>
                                    ${this.voucherResponse ? html`
                                        <div style="margin-top:-30px;margin-bottom: 30px;margin-left: auto;color: var(--app-red);">${this.voucherResponse}</div>
                                    ` : ``}
                                </div>
                                
                                <div class="layout horizontal">
                                    <div class="layout vertical flex">
                                        <p>U wordt doorverwezen naar de betalingsomgeving waar u de betaling kunt voortzetten. Al onze betalingen verlopen via mollie.nl.</p>
                                        <p>Met het invullen van het aanmeldformulier gaat u akkoord met de <a target="_blank" href="https://www.cahag.nl/annuleringsvoorwaarden-cahag-cursussen">algemene voorwaarden</a> en geeft u CAHAG toestemming om de persoonsgegevens te verwerken en te gebruiken voor de doeleinden zoals genoemd in ons <a target="_blank" href="https://www.cahag.nl/privacybeleid">privacybeleid</a>.</p>
                                        <input-checkbox @click="${this.checkSubmitButton}" id="input-agreed" name="agreed" label="Ja, ik ga akkoord met de algemene voorwaarden en het privacybeleid."></input-checkbox>
                                    </div>
                                    
                                    <div class="flex layout vertical end-justified align-right">
                                        <button-contained ?disabled="${!this.isValidForm}" style="margin-right: 0;" @click="${this.submit}" label="aanmelden & afrekenen"></button-contained>
                                    </div>
                                </div>
                        ` : html`
                                <div class="layout horizontal">
                                    <div class="layout vertical flex">
                                        <p>Dit aanmeldformulier is verlopen. Kijk op de website van <a href="cahag.nl">cahag.nl</a> voor nieuwe congressen en scholingen.</p>
                                    </div>
                                </div>
                        `}           
                    </div>
                   
                    
                   
                </div>
            ` : ``}
            
            
            
        `;
    }

    checkCoupon() {
        const voucher = this.shadowRoot.getElementById('voucherCode').shadowRoot.querySelector('input').value;
        store.dispatch(createObject("voucher", {voucher_code:voucher, target_id: this.object.id})).then((response) => {
            if(response.type === 'percentage') {
                const total = this.object.price * (response.discount/100);
                response['amount'] = total;

            } else {
                response['amount'] = response.discount;
            }

            response['voucher_code'] = voucher;
            this.voucherCodes[voucher] = response;
            this.voucherAmount = Object.values(this.voucherCodes).reduce((prev, cur) =>{
                return prev + cur.amount;
            }, 0);
            this.voucherApplied = true;

            this.requestUpdate();
        }).catch((response)=> {
            this.voucherResponse = response.error;
        });
    }

    checkSubmitButton(e) {
        this.isValidForm = e.target.shadowRoot.querySelector('input').checked;
    }

    removeParticipant(index) {
        this.participants = [...this.participants.splice(1, index)]
    }

    addParticipant() {
        this.participants = [...this.participants, {}];
    }

    formToData(form){
        const formElements = getFormElements(form.shadowRoot.querySelector('form'));
        if(!validateForm(formElements)){
            return;
        }

        const data = formToJSON(formElements);
        return data
    }

    submit() {
        const forms = this.shadowRoot.querySelectorAll('sw-form');
        let result = [];
        let practice = this.formToData(forms[0]);
        let program = this.formToData(forms[forms.length-1]);
        let isValid = true;
        forms.forEach( (form, index) => {

            if(index === 0 || index === forms.length-1) {
                return;
            } else {
                const data = this.formToData(form);
                if(!data) {
                    isValid = false;
                    return;
                }
                data['practice'] = practice;
                data['program'] = program['program'];
                result.push(data);
            }

        });

        if(!practice || !program || !isValid){
            return;
        }

        // Add agreement to first person
        result[0]['agreed'] = this.shadowRoot.getElementById('input-agreed').shadowRoot.querySelector('input').checked;

        const json = {event_id:this.object.id, data:result};
        if(this.voucherApplied) {
            json['voucher_codes'] = Object.values(this.voucherCodes).map((voucher)=> {
                return voucher['voucher_code'];
            })
        }

        sessionStorage.setItem('event_'+this.object.id, JSON.stringify(result));
        store.dispatch(createObject("enrollment", json)).then((response) => {
            window.location = response.data.checkout_url;
        });
    }
}


window.customElements.define("page-event", PageEvent);
